module.exports = __webpack_public_path__ + "img/27.5564b3a0.jpg";